import { useState, useEffect, useCallback } from 'react';
import { quizApi } from '../../services/quizApi';

export const useQuizResults = (quizId, propResults, propQuiz) => {
  const [quiz, setQuiz] = useState(propQuiz);
  const [results, setResults] = useState(propResults);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userEmail = localStorage.getItem('userEmail');

  const fetchQuizResults = useCallback(async () => {
    if (!quizId || !userEmail) {
      setLoading(false);
      setError('Quiz ID or user email not found.');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const fetchedResults = await quizApi.getQuizResults(quizId, userEmail);
      setResults(fetchedResults);
      const fetchedQuiz = await quizApi.getQuiz(quizId, userEmail);
      setQuiz(fetchedQuiz);
    } catch (err) {
      setError(err.message || 'Failed to load quiz results.');
    } finally {
      setLoading(false);
    }
  }, [quizId, userEmail]);

  useEffect(() => {
    if (!propResults && !propQuiz) {
      fetchQuizResults();
    } else {
      setLoading(false);
    }
  }, [propResults, propQuiz, fetchQuizResults]);

  return {
    quiz,
    results,
    loading,
    error,
    refetch: fetchQuizResults
  };
};
